(function () {
  const SHIELD_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"
         style="width:100%;height:100%;color:#a86f5f;display:block;margin-top:-8px;">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="m9.667 11.5 2 2 4.5-4.5m4.5 3c0 4.908-5.355 8.478-7.303 9.615-.22.129-.332.194-.488.227a1.1 1.1 0 0 1-.42 0c-.155-.034-.266-.098-.487-.227C10.02 20.478 4.667 16.908 4.667 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 0 1 .547-.79c.276-.243.65-.383 1.399-.664l5.362-2.01c.208-.078.311-.117.418-.133a1 1 0 0 1 .287 0c.106.016.21.055.418.133l5.362 2.01c.749.28 1.123.421 1.399.664a2 2 0 0 1 .547.79c.13.343.13.743.13 1.542z"/>
    </svg>`;

  // ---- CUSTOM CSS INJECTED INTO SHADOW ROOT ----
  const CUSTOM_CSS = `
    [data-target="info-card-container"] {
      background: #ffffff !important;
      border: none !important;
      border-radius: 0px !important;
      padding: 0 !important;
      box-shadow: none !important;
      margin-top: 8px !important;
      max-height: 68px !important;
    }

    /* Strip the app's padding from the card's inner wrappers. Their hashed
       _v-* class names change between Redo releases, so match the direct
       children structurally rather than by name. */
    [data-target="info-card-container"] > div {
      padding: 0 !important;
    }

    [data-target="info-card-container"] ._w-2{
      margin-right: 12px !important;
    }

    [data-target="coverage-button"] {
      background: #000000 !important;
      color: #fff !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      height: 58px !important;
      border: 2px solid #000000 !important;
      letter-spacing: 2.5px !important;
    }

    [data-target="coverage-button"]:hover {
      background: transparent !important;
      color: #000 !important;
    } 

    [data-target='headline-text-container'] p{
      letter-spacing: 2.5px;
    }

    [data-target="info-card-image"] {
      width: 44px !important;
      height: 44px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-right: 12px !important;
    }

    [data-target="toggle-label"] {
      font-weight: 700 !important;
      color: #000 !important;
      font-size: 14px !important;
    }

    [data-target="toggle-subtext"] {
      color: #000 !important;
      font-size: 12px !important;
    }

    [data-target="price"] {
      font-weight: 500 !important;
      color: #000 !important;
      font-size: 15px !important;
    }

    [data-target="toggle-info-button"] {
      color: #a86f5f !important;
    }

    [data-target="toggle-info"] svg{
      margin-left: 5px !important;
    }

    [data-target="non-coverage-button"]{
      font-weight: 100 !important;
      margin-bottom: 0px !important;
    }

    [data-target="checkout-buttons-container"] ._u-1{
      margin-top: 8px !important;
      margin-bottom: 10px !important;
    }
    
    [data-target="checkout-buttons-container"] ._u-3{
      line-height: 20px !important;
    }
  `;
  const STYLE_ID = 'custom-redo-style';

  const toTitleCase = (s) =>
    s.replace(/\w\S*/g, (w) =>
      /^(a|an|and|or|the|of|in|on|for|to|\+)$/i.test(w)
        ? w.toLowerCase()
        : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    );

  const injectStyle = (root) => {
    let styleEl = root.getElementById(STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      styleEl.textContent = CUSTOM_CSS;
    }
    // Always move to the end so our rules win over any styles Redo
    // appends/replaces during its own rendering.
    if (root.lastElementChild !== styleEl) root.appendChild(styleEl);
  };

  const applyStyles = (root) => {
    injectStyle(root);

    // Replace brand logo <img> with shield SVG
    const img = root.querySelector('[data-target="info-card-image"]');
    if (img && img.tagName === 'IMG') {
      const wrapper = document.createElement('div');
      wrapper.setAttribute('data-target', 'info-card-image');
      wrapper.className = img.className;
      wrapper.innerHTML = SHIELD_SVG;
      img.replaceWith(wrapper);
    }

    // Title-case the subtext
    const sub = root.querySelector('[data-target="toggle-subtext"]');
    if (sub && !sub.dataset.styled) {
      sub.textContent = toTitleCase(sub.textContent);
      sub.dataset.styled = '1';
    }

    // Update non-coverage button text (only once)
    const noCoverageBtn = root.querySelector('[data-target="non-coverage-button"]');
    if (noCoverageBtn && !noCoverageBtn.dataset.textUpdated) {
      const textEl = noCoverageBtn.querySelector('p');
      if (textEl) {
        textEl.textContent = 'Checkout without free returns';
        noCoverageBtn.dataset.textUpdated = '1';
      }
    }

    // Update coverage button text to remove "US" from currency (only once)
    const coverageBtn = root.querySelector('[data-target="coverage-button"]');
    if (coverageBtn && !coverageBtn.dataset.textUpdated) {
      const headlineEl = coverageBtn.querySelector('[data-target="headline-text-container"] p');
      if (headlineEl) {
        headlineEl.textContent = headlineEl.textContent.replace(/US/g, '');
        coverageBtn.dataset.textUpdated = '1';
      }
    }

    // Update price text to remove "US" from currency
    const priceEl = root.querySelector('[data-target="price"]');
    if (priceEl && !priceEl.dataset.textUpdated) {
      priceEl.textContent = priceEl.textContent.replace(/US/g, '');
      priceEl.dataset.textUpdated = '1';
    }

    // Replace the default info button with our own clone to strip Redo's handlers.
    const infoBtn = root.querySelector('[data-target="toggle-info-button"]');
    if (infoBtn && !infoBtn.dataset.customHandled) {
      const clone = infoBtn.cloneNode(true);
      clone.dataset.customHandled = '1';
      clone.onclick = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        openCustomModal();
        return false;
      };
      clone.addEventListener(
        'pointerdown',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
        },
        true
      );
      clone.addEventListener(
        'mousedown',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
        },
        true
      );
      infoBtn.replaceWith(clone);
    }
  };

  // ---- OPEN CUSTOM MODAL ----
  const openCustomModal = () => {
    const modal = document.getElementById('cart-redo-modal');
    if (!modal) return;
    modal.classList.add('cart__redo-modal--active');

    const closeBtn = modal.querySelector('#cart-redo-close');
    const overlay = modal.querySelector('#cart-redo-overlay');
    const closeModal = () => modal.classList.remove('cart__redo-modal--active');

    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.addEventListener('click', closeModal);
      closeBtn.dataset.bound = '1';
    }
    if (overlay && !overlay.dataset.bound) {
      overlay.addEventListener('click', closeModal);
      overlay.dataset.bound = '1';
    }
  };

  const attachToRoot = (host, root) => {
    if (host.__redoObserved) return;
    host.__redoObserved = true;

    const sync = () => applyStyles(root);

    new MutationObserver(sync).observe(root, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    sync();
  };

  const bindHost = (host) => {
    if (!host || host.__redoBound) return;
    host.__redoBound = true;

    // The shadow root may not exist yet, or may be empty when it first appears.
    // Poll until it's present and has children, then hook the MutationObserver.
    let tries = 0;
    const waitForShadow = () => {
      const root = host.shadowRoot;
      if (root && root.firstChild) {
        attachToRoot(host, root);
        return;
      }
      if (tries++ > 150) return; // ~15s safety cap
      setTimeout(waitForShadow, 100);
    };
    waitForShadow();
  };

  const scan = (scope = document) => {
    if (scope.tagName === 'REDO-SHOPIFY-TOGGLE') bindHost(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('redo-shopify-toggle').forEach(bindHost);
    }
  };

  // Watch the whole document for the Redo toggle appearing/reappearing
  // (e.g. when liquid-ajax-cart re-renders the cart drawer section).
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((n) => {
        if (n instanceof Element) scan(n);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Re-scan after any ajax cart update, in case the host was replaced.
  document.addEventListener('liquid-ajax-cart:request-end', () => scan());

  // Also catch the drawer being opened directly.
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ajax-cart-toggle-class-button], [href="/cart"], [data-cart-open]')) {
      setTimeout(() => scan(), 50);
    }
  }, true);

  scan();
})();